/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 11/11/2021
 * @Example
 */


import Api from '../../../services/api';
import { cancel, take, takeLatest } from "redux-saga/effects";
import { types } from "./W05F0011_actions";
import { delay } from "redux-saga";

export default function W05F0011Sagas() {
    return [
        watchGetCboEmployees(),
        watchGetCboObjects(),
        watchGetCboKindVoucher(),
        watchLoadForm(),
        watchOnDelete(),
        watchGetCboStatus(),
        watchOnUpdateStatus(),
    ];
}
export function* getCboEmployees(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0000/get-combo-employee', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getCboEmployees error')
    }
}
export function* watchGetCboEmployees() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0011_GET_CBO_EMPLOYEE, getCboEmployees);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* getCboObjects(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w91f0001/load-objects', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getCboObjects error')
    }
}
export function* watchGetCboObjects() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0011_GET_CBO_OBJECTS, getCboObjects);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* getCboKindVoucher(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0011/get-kind-voucher-list', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getCboKindVoucher error')
    }
}
export function* watchGetCboKindVoucher() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0011_GET_CBO_KIND_VOUCHER, getCboKindVoucher);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* loadForm(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0011/load-form', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('loadForm error')
    }
}
export function* watchLoadForm() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0011_LOAD_FORM, loadForm);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* onDelete(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0011/delete', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('onDelete error')
    }
}
export function* watchOnDelete() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0011_DELETE, onDelete);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* getCboStatus(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0012/get-list', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getCboStatus error')
    }
}
export function* watchGetCboStatus() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0011_GET_CBO_STATUS, getCboStatus);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* onUpdateStatus(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0011/change-status-voucher', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('onUpdateStatus error')
    }
}
export function* watchOnUpdateStatus() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0011_UPDATE_STATUS, onUpdateStatus);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}
